import { render, staticRenderFns } from "./topDownload.vue?vue&type=template&id=b1a07670&scoped=true&lang=html"
import script from "./topDownload.vue?vue&type=script&lang=js"
export * from "./topDownload.vue?vue&type=script&lang=js"
import style0 from "./topDownload.vue?vue&type=style&index=0&id=b1a07670&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a07670",
  null
  
)

export default component.exports